import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './components/Auth Utility/AuthContext';
import { CartProvider } from './components/Cart Utility/CartManager';
import Login from './components/Auth Utility/Login';
import Logout from './components/Auth Utility/Logout';
import AuthCallback from './components/Auth Utility/AuthCallback';
import ProtectedRoute from './components/Auth Utility/ProtectedRoute';
import ProductList from './components/Product Page Utility/ProductList';
import ProductDetail from './components/Product Page Utility/ProductDetail';
import CheckoutPage from './components/Product Page Utility/CheckoutPage';
import CartPage from './components/Product Page Utility/CartPage';
import Profile from './components/Account/Profile';
import Header from './components/Common Utility/Header';
import Footer from './components/Common Utility/Footer';
import './App.css'; // Import global styles
const App = () => {

    return (
        <div className="app-layout">
            <AuthProvider>
            <CartProvider>
                <Router>
                    <Header />
                    <div className="main-content">
                        <Routes>
                            <Route path="/" element={<ProductList />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/logout" element={<Logout />} />
                            <Route path="/auth/callback" element={<AuthCallback />} />
                            <Route
                                path="/products/:id"
                                element={<ProductDetail />}
                            />
                            <Route
                                path="/cart"
                                element={<CartPage />}
                            />
                            <Route
                                path="/checkout"
                                element={
                                    <ProtectedRoute>
                                        <CheckoutPage />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/account"
                                element={
                                    <ProtectedRoute>
                                        <Profile />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                    </div>
                    <Footer />
                </Router>
            </CartProvider>
            </AuthProvider>
        </div>
    );
};

export default App;